class SearchArticle extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#article-search-results');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        // ✅ FIX: Use /search/suggest.json for proper API request
        fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=article&resources[limit]=5`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.json(); // ✅ Parse as JSON instead of text
            })
            .then((data) => {
                const articles = data.resources.results.articles || [];

                if (articles.length === 0) {
                    this.predictiveSearchResults.innerHTML = "<p>No articles found.</p>";
                    this.open();
                    return;
                }

                this.predictiveSearchResults.innerHTML = `
           

                    <ul>
                        ${articles.map(article => `
                            <li>
                                <a href="${article.url}">
                                    <span>${article.title}</span>
                                </a>
                            </li>
                        `).join('')}
                    </ul>
                `;
                this.open();
            })
            .catch((error) => {
                this.close();
                console.error("Error fetching articles:", error);
            });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('search-article', SearchArticle);





class SearchBlog extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#article-search-results');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        const blogHandle = "news"; // ✅ Replace with your actual blog handle

        fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=article&resources[limit]=5&resources[options][blog]=${blogHandle}`)
            .then((response) => {
                if (!response.ok) {
                    this.close();
                    throw new Error(response.status);
                }
                return response.json();
            })
            .then((data) => {
                const articles = data.resources.results.articles || [];

                if (articles.length === 0) {
                    this.predictiveSearchResults.innerHTML = "<p>No blog posts found.</p>";
                    this.open();
                    return;
                }

                this.predictiveSearchResults.innerHTML = `
                    <ul>
                        ${articles.map(article => `
                            <li>
                                <a href="${article.url}">
                                    <span>${article.title}</span>
                                </a>
                            </li>
                        `).join('')}
                    </ul>
                `;
                this.open();
            })
            .catch((error) => {
                this.close();
                console.error("Error fetching blog posts:", error);
            });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('search-blog', SearchBlog);
